import React from 'react'
import DataTable from '../../DataTable/DataTable'
import LoadingSpinner from '../../LoadingSpinner/LoadingSpinner'
import clsx from "clsx"
import numeral from "numeral"

export default class ReservationCardFolios extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: false,
      date_format: this.props.date_format ? this.props.date_format : null,
      folio_items_path: this.props.folio_items_path ? this.props.folio_items_path : null,
      payment_logs_path: this.props.payment_logs_path ? this.props.payment_logs_path: null,
      transactions_active_tab: this.props.transactions_active_tab ? this.props.transactions_active_tab : 'current_charges',
      folios_active_tab: 'open',

    }
    this.onChangeActiveTransactionTab = this.onChangeActiveTransactionTab.bind(this);


  }

  componentDidMount() {
    var self = this;
 

    $(window).on("paymentSavedSuccessfully", function () {
      self.setState({loading: true});
    });

    $(window).on("folioItemSavedSuccessfully", function () {
      self.setState({loading: true});
    });


    $(window).on("folioSavedSuccessfully", function () {
      self.setState({loading:true});
    })


  }


  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == "folios",
      'tab-pane': true
    });

    return(
      <div className={tabClasses} id="folios">
  
        <div className="panel panel-default">
          <div className="panel-body container">
            <h3 className="panel-heading-text">{I18n.t("folios")}</h3>
            <DataTable read_only={this.props.read_only}
              endpoint={this.props.reservation_folios_path} 
              date_format={this.props.date_format} 
              time_format={this.props.time_format} 
              currency_unit={I18n.t('number.currency.format.unit')} 
              delimiter={I18n.t('number.currency.format.delimiter')} 
              separator={I18n.t('number.currency.format.separator')}
              reLoadData={this.props.reLoadData}
              loadDataCallback={this.props.refreshFolioTableCallback}
             /> 
          </div>
        </div>

        <div className="panel panel-default">
          <div className="panel-body container">
            <h3 className="panel-heading-text">{I18n.t("transactions")}</h3>
            <ul className="nav nav-tabs">
              <li role="presentation" className={this.state.transactions_active_tab === "current_charges" ? "active" : null}>
                <a className="nav-link" href="#current_charges" onClick={this.onChangeActiveTransactionTab.bind(null, "current_charges")}>{I18n.t("current_charges")}</a>
              </li>
              <li role="presentation" className={this.state.transactions_active_tab === "voided_charges" ? "active" : null}>
                <a className="nav-link" href="#voided_charges" onClick={this.onChangeActiveTransactionTab.bind(null, "voided_charges")}>{I18n.t("voided_charges")}</a>
              </li>
              <li role="presentation" className={this.state.transactions_active_tab === "payments" ? "active" : null}>
                <a className="nav-link" href="#payments" onClick={this.onChangeActiveTransactionTab.bind(null, "payments")}>{I18n.t("payments")}</a>
              </li>
              <li role="presentation" className={this.state.transactions_active_tab === "authorized_payments" ? "active" : null}>
                <a className="nav-link" href="#payments" onClick={this.onChangeActiveTransactionTab.bind(null, "authorized_payments")}>{I18n.t("authorized_payments")}</a>
              </li>
            </ul>
            <br />
            {this.state.transactions_active_tab === 'authorized_payments' ? <DataTable read_only={this.props.read_only} endpoint={this.props.reservation_authorized_payments_path} reservation_segment={this.props.reservation_segment} date_format={this.props.date_format} time_format={this.props.time_format} tab_data_table={true} inModal={true} currency_unit={I18n.t("number.currency.format.unit")} delimiter={I18n.t('number.currency.format.delimiter')} separator={I18n.t('number.currency.format.separator')} /> : null}

            {this.state.transactions_active_tab === 'payments' ? <DataTable read_only={this.props.read_only} endpoint={this.props.reservation_payments_path} reservation_segment={this.props.reservation_segment} date_format={this.props.date_format} time_format={this.props.time_format} tab_data_table={true} currency_unit={I18n.t("number.currency.format.unit")} delimiter={I18n.t('number.currency.format.delimiter')} separator={I18n.t('number.currency.format.separator')} /> : null}
            {this.state.transactions_active_tab === 'current_charges' ? <DataTable read_only={this.props.read_only} endpoint={this.props.reservation_charges_path} reservation_segment={this.props.reservation_segment} date_format={this.props.date_format} time_format={this.props.time_format} tab_data_table={true} currency_unit={I18n.t('number.currency.format.unit')} delimiter={I18n.t('number.currency.format.delimiter')} separator={I18n.t('number.currency.format.separator')} /> : null}
            {this.state.transactions_active_tab === 'voided_charges' ? <DataTable read_only={this.props.read_only} endpoint={this.props.reservation_voided_charges_path} reservation_segment={this.props.reservation_segment} date_format={this.props.date_format} time_format={this.props.time_format} tab_data_table={true} currency_unit={I18n.t('number.currency.format.unit')} delimiter={I18n.t('number.currency.format.delimiter')} separator={I18n.t('number.currency.format.separator')} /> : null}
          </div>
        </div>
        <LoadingSpinner show={this.state.loading} />
      </div>
    )
  }




  onChangeActiveTransactionTab(tab) {
    if (tab) {
      this.setState({
        transactions_active_tab: tab,
      });
    };
  };


  formatCurrency(num) {
    return I18n.t('number.currency.format.unit') + numeral(num / 100).format('0' + I18n.t('number.currency.format.delimiter') + '0.00');
  };

};
